import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden py-8 lg:py-0" data-id="element-32">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-33">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-[#d4a5a5]/20 blur-[100px]" data-id="element-34" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[600px] h-[600px] rounded-full bg-[#9d4b6b]/10 blur-[120px]" data-id="element-35" />
      </div>

      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left" data-id="element-37">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="inline-block px-4 py-1.5 mb-6 text-sm font-medium tracking-wider text-[#9d4b6b] uppercase bg-[#9d4b6b]/10 rounded-full" data-id="element-38">
            Guía Exclusiva para la Mujer Latina
          </motion.span>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#2d2d2d] leading-[1.1] mb-6 tracking-tight" data-id="element-39">
            EL DIVORCIO <span className="text-[#9d4b6b] italic" data-id="element-40">EMOCIONAL</span>
          </h1>

          <p className="text-xl md:text-2xl text-[#5a5a5a] mb-8 font-light leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-41">
            La guía que transforma la desconexión silenciosa en un renacer
            amoroso.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-42">
            <CTAButton scrollToPurchase data-id="element-43">Comienza Tu Renacer Hoy</CTAButton>
            <p className="text-sm text-[#8b6f6f] italic mt-2 sm:mt-0" data-id="element-44">
              Disponible descarga inmediata
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        rotate: -2
      }} animate={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: 'easeOut'
      }} className="relative flex justify-center lg:justify-end" data-id="element-45">
          <div className="relative z-10 w-[280px] md:w-[380px] lg:w-[450px] shadow-2xl shadow-[#9d4b6b]/30 rounded-lg overflow-hidden transform hover:scale-[1.02] transition-transform duration-500" data-id="element-46">
            <img src="https://cdn.magicpatterns.com/uploads/qfVmSh5sWYSJ6KRRXesGMW/COVER_EL_DIVORCIO_EMOCIONAL_EBOOK.png" alt="Portada del libro El Divorcio Emocional" className="w-full h-auto object-cover" data-id="element-47" />
            {/* Glossy overlay effect */}
            <div className="absolute inset-0 bg-gradient-to-tr from-black/10 to-transparent pointer-events-none" data-id="element-48" />
          </div>

          {/* Decorative backdrop behind book */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] border border-[#9d4b6b]/20 rounded-full -z-10" data-id="element-49" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[140%] h-[140%] border border-[#9d4b6b]/10 rounded-full -z-10" data-id="element-50" />
        </motion.div>
      </div>
    </section>;
}